import { render, staticRenderFns } from "./GoliaShareNetwork.vue?vue&type=template&id=7de3ada4&scoped=true"
import script from "./GoliaShareNetwork.vue?vue&type=script&lang=js"
export * from "./GoliaShareNetwork.vue?vue&type=script&lang=js"
import style0 from "./GoliaShareNetwork.vue?vue&type=style&index=0&id=7de3ada4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de3ada4",
  null
  
)

export default component.exports